import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useConsolidationSummaryStudents } from '@/features/dashboard/api/getConsolidationSummaryStudents';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import { TitlePages } from '@/components/Base/TitlePage';
import Thermometer from '@/components/Base/Thermometer';
import { useTermometroFinanceiroDetalhes } from '@/features/termometro/getTermometroFinanceiroDetalhes';
import KpiComponentGreen from '@/components/Base/KpiComponentGreen';
import { useTermometroGeralDetalhes } from '@/features/termometro/getTermometroGeralDetalhes';

export const TermometroGeralAlunos = ({ routeBack }) => {
  const [open, setOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const location = useLocation();
  const { id, name } = location.state || {};

  // const redirectRaioX = () => {
  //   navigate(, { state: { id, name } })
  // }

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroGeralDetalhes(id);
  const {
    data,
    isFetching: isFetchingStudents,
    isFetched: isFetchedStudents,
  } = useConsolidationSummaryStudents({ year: selectedYear, month: selectedMonth });

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  const getPositionFromScore = (mediumscore) => {
    if (mediumscore >= 0 && mediumscore < 3.33) {
      return 'end';
    } else if (mediumscore >= 3.33 && mediumscore < 6.66) {
      return 'center';
    } else if (mediumscore >= 6.66 && mediumscore <= 10) {
      return 'start';
    } else {
      return 'end';
    }
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <TitlePages title={'Termômetro geral por aluno'} />
        </Stack>

        <Stack flexDirection={'row'}>

        <Button
            onClick={() => navigate('/raiox-termometro-alunos', { state: { id, name } })}
            variant="contained"
            sx={{ mr: '10px', fontWeight:'700', borderRadius: '24px', fontSize: '14px', height: '37px', color: '#000', textTransform: 'capitalize', backgroundColor: '#96C227'}}
          >
            Raio X
          </Button>


          <Button
            onClick={() => navigate('/inadimplencia-recomendacoes-alunos', { state: { id, name } })}
            variant="contained"
            sx={{ fontWeight:'700', borderRadius: '24px', fontSize: '14px', height: '37px', color: '#fff', textTransform: 'capitalize', backgroundColor: '#15AB51'}}
          >
            Visualizar recomendação
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponentGreen title={'Score geral'} 
                value={String(summary?.medium_score).replace('.', ',')} 
                // value={"9,5"}
                />
              <KpiComponent title={'Situação'} 
                value={summary?.is_active ? 'Ativo' : 'Inativo'} 
              />
              <KpiComponent title={'% desconto'} 
                value={`${summary?.total_discount}%`} 
                // value={"10%"}
              />
              <KpiComponent title={'Score financeiro'} 
                value={`${summary.financial_score.bolsista ? 'Bolsista' : summary.financial_score.value}`} 
                // value={"8"}
              />
              <KpiComponent title={'Score frequência'} 
                value={`${summary?.frequency_score}`}
                // value={"7"}
              />
              <KpiComponent title={'Score pedagógico'} 
                value={`${summary?.pedagogical_score}`} 
                // value={"8"}
              />
            </Stack>
          </Stack>
        )}
        {isFetching && !summary && <LoadingSummary />}
        <Box >
          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer
              score={summary?.medium_score || 0}
            />
          </Box>

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
              <Box fontSize={'16px'} fontWeight={400}>
                Aluno(a): <span style={{ fontWeight: 600 }}>{`${(summary?.name || name)} ${summary?.student_info?.serie ? `- ${summary?.student_info?.serie}` : ''}`}</span>
              </Box>

              {summary?.medium_score < 6 && <Box maxWidth={'477px'} fontStyle={'italic'} color={'#E04A4C'}>
                . Em decorrência do score do aluno abaixo da média, é necessário o registro de uma advertência.
              </Box>}
            </Stack>

            <Stack maxWidth={'470px'} mt={'40px'} flexDirection={'row'} justifyContent={'space-between'}>
              <Typography fontWeight={'600'} fontSize={'14px'} color={'#3F4254'}>
                Score geral máximo
              </Typography>

              <Typography fontWeight={'600'} fontSize={'14px'} color={'#000'}>
                {summary?.max_min_values
                  ? String(summary?.max_min_values?.maximum_value?.value).replace('.', ',')
                  : '-'}
              </Typography>
            </Stack>

            <Stack maxWidth={'470px'} mt={'40px'} flexDirection={'row'} justifyContent={'space-between'}>
              <Typography fontWeight={'600'} fontSize={'14px'} color={'#3F4254'}>
                Score geral mínimo
              </Typography>

              <Typography fontWeight={'600'} fontSize={'14px'} color={'#000'}>
                {summary?.max_min_values
                  ? String(summary?.max_min_values?.minimal_score?.value).replace('.', ',')
                  : '-'}
              </Typography>
            </Stack>

            <Stack maxWidth={'470px'} mt={'40px'} flexDirection={'row'} justifyContent={'space-between'}>
              <Typography fontWeight={'600'} fontSize={'14px'} color={'#3F4254'}>
                Advertências recebidas
              </Typography>

              <Typography fontWeight={'600'} fontSize={'14px'} color={'#000'}>
                {summary?.total_warnings
                  ? summary.total_warnings
                  : '-'}
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Box>
    </>
  );
};
